export default "__VITE_ASSET__B8pXlV71__"